import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-compass-icon',
  standalone: true,
  templateUrl: './compass-icon.component.html',
  styleUrls: ['./compass-icon.component.scss']
})
export class CompassIconComponent {
  @Input() width: number | string = 19;
  @Input() height: number | string = 19;
}
